import { useIpRestrictionStore } from "@/stores/useIpRestrictionStore";

// 既定は空 (同一オリジン相対)。本番/kind は ingress が `/api` を backend へ振り分け、
// ホストの Vite dev サーバーは vite.config.ts のプロキシが同じく backend へ委譲する。
export const API_URL: string = import.meta.env.VITE_API_URL ?? "";

interface ApiFetchInit extends RequestInit {
	redirectOn401?: boolean;
}

export async function apiFetch(
	path: string,
	{ redirectOn401 = true, ...init }: ApiFetchInit = {},
): Promise<Response> {
	const headers = new Headers(init?.headers);
	if (!headers.has("Content-Type") && !(init?.body instanceof FormData)) {
		headers.set("Content-Type", "application/json");
	}
	const res = await fetch(`${API_URL}${path}`, { ...init, headers, credentials: "include" });
	if (res.status === 401 && redirectOn401) {
		window.location.replace("/login");
	}
	await markBlockedIfIpNotAllowed(res);
	return res;
}

/**
 * 組織の接続元 IP 制限による拒否なら拒否を記録して true を返す。
 * 本文は呼び出し側でも読めるよう複製から読むため、本文を読む前に呼ぶ。
 */
export async function markBlockedIfIpNotAllowed(res: Response): Promise<boolean> {
	if (res.status !== 403) return false;
	const body: unknown = await res
		.clone()
		.json()
		.catch(() => null);
	const blocked =
		typeof body === "object" &&
		body !== null &&
		(body as { type?: unknown }).type === "ip_not_allowed";
	if (blocked) useIpRestrictionStore.getState().markBlocked();
	return blocked;
}
